<template>
<div class="donotprint">
    <div class="donotprint">
        <a @click="toggleshowVerificationList" class="annotator-toggle cursor-pointer fixed right-0 top-0 flex lg:hidden justify-center items-center w-48 h-10 text-red-100 text-xl leading-snug z-20 bg-gray-900 rounded-bl-lg -ml-48 mt-0 no-underline font-mono">
            VERIFICATION <i aria-hidden="true" class="material-icons text-2xl pl-2">forward</i>
            <div class="fixed top-0 right-0 h-screen block w-2 bg-gray-900"></div>
        </a>
    </div>
    <div
        class="type-verification donotprint w-5/6 md:w-1/2 lg:w-1/6 z-40 xl:w-1/6 xxl:w-3/12"
        :class="showVerificationList ? 'block' : 'hidden lg:block'"
    >
        <a @click="toggleshowVerificationList" class="flex justify-center items-center cursor-pointer w-8 h-8 fixed top-0 lg:hidden text-red-100 z-50 bg-gray-900 rounded-l-lg -ml-8 mt-1 no-underline"><i aria-hidden="true" class="material-icons text-2xl">cancel</i></a>
        <span class="hidden justify-end items-center w-48 h-10 fixed top-0 lg:flex text-red-100 text-xl leading-snug z-50 bg-gray-900 rounded-bl-lg -ml-48 mt-0 no-underline font-mono">
            VERIFICATION <i aria-hidden="true" class="material-icons text-2xl pl-1">forward</i>
        </span>
        <div class="text-yellow-300 text-sm h-10 flex items-center content-center font-normal text-center leading-snug pl-2">
            Select a Pattern to View
        </div>
        <div class="text-xxs text-center mb-2 px-2">
            <template v-if="show_confirm">
                <a @click="toggleReadyToConfirm" class="btn block mt-0">
                    <template v-if="ready_to_confirm">
                        Keep Looking
                    </template>
                    <template v-else>
                        Ready To Confirm?
                    </template>
                </a>
            </template>
            <template v-else>
                When you have viewed at least 3, you will be able to confirm your likely best-fit pattern.
            </template>
        </div>
        <ul>
            <!-- NOT READY TO CONFIRM TOP 5-->
            <li v-for="tab in type_scores.slice(0, 5)"
                :key="tab.id"
                class="match"
                :class="{ 'active': tab.name == active }"
                v-if="!ready_to_confirm"
            >
                <a class="thelink flex flex-col" :href="'?result=' + tab.id + currentHash">
                    <div class="pattern-colors flex flex-row -mx-3 -mt-1 mb-1"
                    >
                        <div class="w-2/3" :style="'background-color: ' + tab.dominant_color"></div>
                        <div class="w-1/3" :style="'background-color: ' + tab.auxiliary_color"></div>
                    </div>
                    <span v-if="have_verified == tab.name_hidden" class="current-verified">Current Verified Pattern</span>
                    <div class="pattern-title flex items-center justify-between">
                        <div class="pl-1">
                            {{ tab.ordinal }}
                        </div>
                        <span
                            class="mr-auto ml-2 px-1 rounded bg-gray-200 text-gray-800 flex justify-center items-center"
                            :class="{ 'text-green-700': tab.name == active }">
                                {{ tab.score }}
                        </span>
                        <div v-if="tab.seen == true" class="viewed large">
                            <eyeicon-seen></eyeicon-seen>
                        </div>
                        <div v-else class="viewed large">
                            <eyeicon-unseen></eyeicon-unseen>
                        </div>
                    </div>
                </a>
            </li>
            <!-- READY TO CONFIRM TOP 5 -->
            <li class="match"
                :class="{ 'active': tab.name == active }"
                v-for="tab in type_scores.slice(0, 5)"
                :key="tab.id"
                v-if="ready_to_confirm && tab.seen == true">
                <verification-confirm
                    :demo="demo"
                    :type="tab.name"
                    :name="tab.name_hidden"
                    :ordinal = "tab.ordinal"
                    initialaccuracy="65"
                    route="/verification"
                    :userid="user_id"
                    :primarycolor="tab.dominant_color"
                    :secondarycolor="tab.auxiliary_color"
                    :redirectlink="redirect_link"
                ></verification-confirm>
            </li>
             <!-- NOT READY TO CONFIRM BOTTOM 11 -->
            <li v-for="tab in type_scores.slice(5, 16)"
                :key="tab.id"
                class="match small"
                :class="{ 'active': tab.name == active }"
                v-if="!ready_to_confirm"
            >
                <a class="thelink flex flex-col" :href="'?result=' + tab.id + currentHash">
                    <div class="pattern-colors flex flex-row h-1 -mx-3 -mt-1 mb-1"
                        :class="tab.name == active ? 'border-gray-600' : 'border-gray-900'"
                    >
                        <div class="w-2/3" :style="'background-color: ' + tab.dominant_color"></div>
                        <div class="w-1/3" :style="'background-color: ' + tab.auxiliary_color"></div>
                    </div>
                    <span v-if="have_verified == tab.name_hidden" class="current-verified">Current Verified Pattern</span>
                    <div class="pattern-title flex items-center justify-between">
                        {{ tab.ordinal }}
                        <span
                            class="mr-auto ml-2 px-1 rounded bg-gray-700 text-white flex justify-center items-center"
                            :class="{ 'text-green-700': tab.name == active }">
                                {{ tab.score }}
                        </span>
                        <div v-if="tab.seen == true" class="viewed">
                            <eyeicon-seen></eyeicon-seen>
                        </div>
                        <div v-else class="viewed">
                            <eyeicon-unseen></eyeicon-unseen>
                        </div>
                    </div>
                </a>
            </li>
            <!-- READY TO CONFIRM BOTTOM 11 -->
            <li class="match small"
                :class="{ 'active': tab.name == active }"
                v-for="tab in type_scores.slice(5, 16)"
                :key="tab.id"
                v-if="ready_to_confirm && tab.seen == true">
                <verification-confirm
                    :demo="demo"
                    :type="tab.name"
                    :name="tab.name_hidden"
                    :ordinal = "tab.ordinal"
                    initialaccuracy="65"
                    route="/verification"
                    :userid="user_id"
                    :primarycolor="tab.dominant_color"
                    :secondarycolor="tab.auxiliary_color"
                    :redirectlink="redirect_link"
                ></verification-confirm>
            </li>
        </ul>

    </div>
</div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'

export default {
    components: {
        ToggleButton,
    },

    props: {
        enabled: true,
        type_scores: {},
        active: {},
        show_confirm: '',
        userid: '',
        demo:'',
        redirect_link: '',
        have_verified: '',
    },

    data() {
        return {
            showVerificationList: this.getInitialShowVerificationList(),
            currentHash: '',
            ready_to_confirm: false,
            user_id: this.userid,
        }
    },

    created() {
        this.$root.$on('reportNavChanged', (currentItem) => {
            if (currentItem && currentItem.hash.charAt(0) === '#') {
                this.currentHash = currentItem.hash;
            }
        });
    },

    methods: {
        toggleshowVerificationList() {
            this.showVerificationList = ! this.showVerificationList;
        },
        toggleReadyToConfirm() {
            this.ready_to_confirm = !this.ready_to_confirm;
        },
        getInitialShowVerificationList() {
            return window.innerWidth > 1024;
        },
    },
}
</script>
